var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128034(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-128_034-1,.cls-128_034-3{fill:#fff;}.cls-128_034-2,.cls-128_034-4{fill:none;}.cls-128_034-2{opacity:0.2;}.cls-128_034-3{stroke:#6e6e6e;stroke-linejoin:round;}.cls-128_034-3,.cls-128_034-4{stroke-linecap:round;stroke-width:1.25px;}.cls-128_034-4{stroke:#ff6a10;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128_034-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128_034-2",
    width: 128,
    height: 128
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128_034-3",
    d: "M52.77,29.42l-.17,1L48.85,54c-1.48,8.82-1.75,14.07-4.05,22.13a1.78,1.78,0,0,1-.26.58s-5,2.94-6.55.33L27.39,58.58C25,54.33,20,57,20,57c-2.17,1.32-3,4-1.63,7.07,0,0,11,30.1,11.73,32.6,6,20,17.55,22,28,22,10.64,0,15.31-2.15,22.39-11l28.72-41.25a4.57,4.57,0,0,0,0-5.9,4.48,4.48,0,0,0-6.8.15L89.11,76.11s-2-2.8-2-2.85l14.22-30.83A5,5,0,0,0,99.45,36s-4.52-2.2-7.12,1.77l-15,28.55-2-.84,11.47-34c1.42-4.61-.3-6.24-1.65-7.15,0,0-4.9-2.89-7.85,3.51L64.18,60.37l-2-.62,1.58-29.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128_034-4",
    d: "M54.85,10a11,11,0,0,1,11.3,1.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128_034-4",
    d: "M51.51,14.82s9-8.53,16.81,1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128_034-4",
    d: "M52.42,23.92S50,17.6,55.49,14.56a7.93,7.93,0,0,1,2.45-.85c2.34-.43,6.76-.4,8.57,5.21,0,0,1.36,3.92-1.17,4.59-2.13.56-2.93-.52-3.23-1.34a3.46,3.46,0,0,1-.17-1.06,2.62,2.62,0,0,0-3.13-2.77s-2.68,0-1.79,4.73a6.4,6.4,0,0,0,4,4.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128_034-4",
    d: "M59.33,20.08s-.88,5.73,5.51,5.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128_034-4",
    d: "M64.32,21.36c-.74-3.11-1.22-5.21-5.12-5.27a4.6,4.6,0,0,0-4.83,5.27s.09,3.84,2.37,5.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128034);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_034.48ae85c8b720f4dfe21466b5b67255eb.svg";
export { ForwardRef as ReactComponent };